const summaries = {
  /** @type {SummarySet} */
  discrepancy: {},
  /** @type {SummarySet} */
  pacing: {},
}

export default summaries
